module.exports = __webpack_public_path__ + "img/delivery.99c78811.webp";